import type { ObjecttypeDto } from 'cadenza/api-client/dto/objecttype-dto';
import type { ProjectId } from 'cadenza/repository/model/project-id.gen';
import { repositoryItemIdEquals } from 'cadenza/repository/model/repository-item-id';
import { getStore } from 'cadenza/store/cadenza-store';
import type { Objecttype } from 'cadenza/workbook/api/objecttype';
import { getProject } from 'cadenza/workbook/workbook-core-selectors.state';

export function isComponentProjectObjecttype({ projectId }: Pick<Objecttype | ObjecttypeDto, 'projectId'>) {
  return !!(projectId && isComponentProject(projectId));
}

function isComponentProject(projectId: ProjectId) {
  const componentProjectIds = getProject(getStore().getState())?.componentProjectIds;
  if (componentProjectIds?.length) {
    if (componentProjectIds.some((componentProjectId) => repositoryItemIdEquals(projectId, componentProjectId))) {
      return true;
    }
  }
  return false;
}
